import { toast } from "sonner";

/**
 * Delete-with-undo pattern.
 * Optimistically remove item from UI, show a toast with "Annulla".
 * If user hits Annulla within 4s → run onUndo(), item comes back.
 * If timer expires → run onCommit() which actually deletes on the server.
 *
 * Usage:
 *   deleteWithUndo({
 *     label: "Prodotto eliminato",
 *     onCommit: async () => api.delete(`/products/${id}`),
 *     onUndo: () => setProducts(prev => [...prev, snapshot]),
 *   });
 */
export function deleteWithUndo({ label = "Eliminato", onCommit, onUndo, duration = 4000 }) {
  let undone = false;
  const commitTimer = setTimeout(async () => {
    if (undone) return;
    try {
      await onCommit?.();
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Errore eliminazione");
      onUndo?.();
    }
  }, duration);

  toast(label, {
    duration: duration + 200,
    action: {
      label: "Annulla",
      onClick: () => {
        undone = true;
        clearTimeout(commitTimer);
        onUndo?.();
      },
    },
    actionButtonStyle: undefined,
    // Sonner action buttons don't accept data-testid via config; test IDs handled at page level.
  });
}
